/**
 * Based on the script 'responsive-menu.js' taken from the Infinity Pro theme and modified to use
 * font awesome instead of ionicons
 */

(function ( document, $ ) {
	'use strict';

	var infinity                      = {};
	const mobileToggle                = $( '#mobile-menu-toggle' );
	const mobileMenu                  = $( '#menu-mobile' )
	// This one stays as a string because it's used as a property as well as an ID.
	var subMenuButtonClass    = 'mobile-sub-menu-toggle';

	infinity.init = function () {
		var toggleButtons = {
			// Assign the fa class; the actual icons are done via css
			submenu: $(
				'<button />',
				{
					'class'        : subMenuButtonClass,
					'aria-expanded': false,
					'aria-pressed' : false,
					'role'         : 'button'
				}
			)
			.append( '<i class="fa"></i>' )
			.append(
				$(
					'<span />',
					{
						'class': 'screen-reader-text',
						text   : infinity.params.subMenu
					}
				)
			)
		};



		$( window ).on( 'resize.infinity', _doResize ).triggerHandler( 'resize.infinity' );
		mobileToggle.on( 'click', function ( event ) {
			event.stopPropagation();
			_mobileMenuToggle();
		} );
		$( '.' + subMenuButtonClass ).on( 'click.infinity-subbutton', _submenuToggle );
	}

	// Change Skiplinks and Superfish
	function _doResize() {
		var buttons = $( 'button[id^=mobile-]' ).attr( 'id' );
		if ( typeof buttons === 'undefined' ) {
			return;
		}
		_changeSkipLink( buttons );
		_maybeClose( buttons );
	}

	/**
	 * action to happen when the mobile menu button is clicked
	 */
	function _mobileMenuToggle() {
		// set our 'this' manually to account for all places this function is called
		var $this = mobileToggle;

		_toggleAria( $this, 'aria-pressed' );
		_toggleAria( $this, 'aria-expanded' );
		//resetMobileTabs( 0 );
		$this.toggleClass( 'activated' );

		// This is for a11y
		mobileMenu.attr( 'hidden', function ( _, attr ) {
			return !attr;
		} );
		// This is for styling
		mobileMenu.slideToggle( 'fast' );
	}

	/**
	 * action for submenu toggles
	 */
	function _submenuToggle() {

		var $this  = $( this ),
		    others = $this.closest( '.menu-item' ).siblings();
		_toggleAria( $this, 'aria-pressed' );
		_toggleAria( $this, 'aria-expanded' );
		$this.toggleClass( 'activated' );
		$this.next( '.sub-menu' ).slideToggle( 'fast' );

		others.find( '.' + subMenuButtonClass ).removeClass( 'activated' ).attr( 'aria-pressed', 'false' );
		others.find( '.sub-menu' ).slideUp( 'fast' );

	}


	/**
	 * modify skip links to match mobile buttons
	 */
	function _changeSkipLink( buttons ) {
		var startLink = 'genesis-nav',
		    endLink   = 'mobile-genesis-nav';
		if ( 'none' === _getDisplayValue( buttons ) ) {
			startLink = 'mobile-genesis-nav';
			endLink   = 'genesis-nav';
		}
		$( '.genesis-skip-link a[href^="#' + startLink + '"]' ).each(
			function () {
				var link = $( this ).attr( 'href' );
				link     = link.replace( startLink, endLink );
				$( this ).attr( 'href', link );
			}
		);
	}

	function _maybeClose( buttons ) {
		if ( 'none' !== _getDisplayValue( buttons ) ) {
			return;
		}
		$( '.menu-toggle, .sub-menu-toggle' )
		.removeClass( 'activated' )
		.attr( 'aria-expanded', false )
		.attr( 'aria-pressed', false );
		$( 'nav, .sub-menu' )
		.attr( 'style', '' );
	}

	/**
	 * generic function to get the display value of an element
	 * @param  {id} $id ID to check
	 * @return {string}     CSS value of display property
	 */
	function _getDisplayValue( $id ) {
		var element = document.getElementById( $id ),
		    style   = window.getComputedStyle( element );
		return style.getPropertyValue( 'display' );
	}

	/**
	 * Toggle aria attributes
	 * @param  {button} $this     passed through
	 * @param  {aria-xx} attribute aria attribute to toggle
	 * @return {bool}           from _ariaReturn
	 */
	function _toggleAria( $this, attribute ) {
		$this.attr(
			attribute,
			function ( index, value ) {
				return 'false' === value;
			}
		);
	}


	/**
	 * Handles closing the dropdowns when the Escape Key is pressed.
	 *
	 * @param  event
	 * @return void
	 */
	function _handleEscKey( event ) {
		let { keyCode }      = event;
		let isDropdownActive = mobileMenu.is( ':visible' );
		if ( 27 === keyCode && isDropdownActive ) {
			mobileToggle.toggleClass( 'activated' );
			mobileMenu.slideToggle( 'fast' ); // Toggle visibility
		}
	}


	/**
	 * Handles click events when clicking outside of shown mobile menu.
	 * This helps with user experience and closes dropdown when
	 * interacting with other UI
	 *
	 * @param event
	 * @return void
	 */
	function _handleClickOutside( event ) {
		const elementClicked   = event.target;
		const isDropdownActive = mobileMenu.is( ':visible' );
		if ( !mobileMenu.find( elementClicked ).length && isDropdownActive && !$( elementClicked ).is( '#mobile-menu-toggle' ) ) {
			mobileToggle.toggleClass( 'activated' );
			mobileMenu.attr( 'hidden', true ); // Remove the hidden attribute
			mobileMenu.slideToggle( 'fast' ); // Toggle visibility
		}
	}


	/**
	 * The Seal section has to be copied out of the primary desktop mega menu and
	 * pasted into its home in the mobile menu. Both are the same, so we choose wwad.
	 */
	function relocateSeal() {
		let sealData      = $( '#nav-primary ul.seal' ).first();
		let sealTarget    = $( '#nav-mobile li.seal-mobile' ).first();
		let sealDataHtml  = sealData.html();
		let sealContainer = $( '<ul></ul>' ).append( sealDataHtml );
		sealTarget.html( sealContainer );
	}


	$( document ).ready(function () {

		// Set the hidden attribute on all menus that start hidden
		//$('ul#nav-mobile').attr( 'hidden', true );

		relocateSeal();

		// Close all mega menus on page load
		$( '#nav-mobile li.mega-menu-container > ul.mega-menu' ).hide();

		// Simple accordion: bind to the top-level anchor within any mega-menu container
		$( '#nav-mobile li.mega-menu-container > a' ).on( 'click', function (event) {
			event.preventDefault();
			event.stopPropagation();
			// Close language dropdown
			$( '#nav-mobile .wpml-submenu' ).slideUp();
			$( '#nav-mobile .wpml-language-selector' ).removeClass( 'activated' );
			const $li = $( this ).closest( 'li.mega-menu-container' );
			// Close any other open mega menus
			$( '#nav-mobile li.mega-menu-container' )
				.not( $li )
				.removeClass( 'mega-open' )
				.children( 'ul.mega-menu' )
				.slideUp();
			$li.toggleClass( 'mega-open' );
			$li.children( 'ul.mega-menu' ).slideToggle();
		} );

		$( '#nav-mobile .wpml-language-selector' ).on( 'click', function (event) {
			$( '#nav-mobile li.mega-menu-container > ul.mega-menu' ).slideUp();
			$( '#nav-mobile li.mega-menu-container' ).removeClass( 'mega-open' );

			$( '#nav-mobile .wpml-submenu' ).slideToggle();
			$( this ).toggleClass( 'activated' );
			event.stopPropagation();
			//event.preventDefault();
		} );

		// If esc is clicked, close the menu
		document.addEventListener( 'keydown', _handleEscKey, false );

		// If anything outside the menu is clicked, close the menu
		document.addEventListener( 'click', _handleClickOutside, false );

		// Localization as passed through via php. See setup.php
		infinity.params = typeof InfinityL10n === 'undefined' ? '' : InfinityL10n;

		if ( typeof infinity.params !== 'undefined' ) {
			infinity.init();
		}

	});

})( document, jQuery );
